import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-134eeb3f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-content-end" }
const _hoisted_2 = { class: "row-expansion-content" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "d-flex flex-wrap" }
const _hoisted_5 = {
  key: 0,
  class: "training-summary"
}
const _hoisted_6 = { class: "mb-1" }
const _hoisted_7 = { class: "text-underline" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ml-1 popover-icon pi pi-question" }, null, -1))
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["title"]
const _hoisted_11 = { class: "training-summary" }
const _hoisted_12 = { class: "mb-1" }
const _hoisted_13 = { class: "text-underline" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ml-1 popover-icon pi pi-question" }, null, -1))
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = ["title"]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = ["title"]
const _hoisted_20 = { key: 2 }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_Message = _resolveComponent("Message")!
  const _component_PopoverIcon = _resolveComponent("PopoverIcon")!
  const _component_Inplace = _resolveComponent("Inplace")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_TrainingAddParticipantsModal = _resolveComponent("TrainingAddParticipantsModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.vm?.training)
      ? (_openBlock(), _createBlock(_component_DataTable, {
          key: 0,
          editingRows: _ctx.editingRows,
          "onUpdate:editingRows": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editingRows) = $event)),
          "expanded-rows": _ctx.expandedRows,
          "onUpdate:expandedRows": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.expandedRows) = $event)),
          "auto-layout": "",
          "data-key": "id",
          "edit-mode": "row",
          "row-class": _ctx.highlightRow,
          "row-hover": _ctx.vm?.training?.canBeEdited,
          value: _ctx.currentRows,
          onRowClick: _withModifiers(_ctx.onRowClick, ["self"])
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              (_ctx.canAddParticipant)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    class: "p-button-raised p-button-primary p-button-sm",
                    icon: "pi pi-plus-circle",
                    "icon-pos": "left",
                    label: _ctx.$t('myCadac.trainingDetail.button.addParticipant'),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onAddParticipantClick()))
                  }, null, 8, ["label"]))
                : _createCommentVNode("", true)
            ])
          ]),
          expansion: _withCtx((item) => [
            _createElementVNode("div", _hoisted_2, [
              (_ctx.vm.howToStartTrainingLink)
                ? (_openBlock(), _createBlock(_component_Message, {
                    key: 0,
                    class: "mt-0",
                    closable: false,
                    severity: "info"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_i18n_t, { keypath: "myCadac.trainingDetail.table.vdiInfo.firstTimeHelp" }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", {
                            href: _ctx.vm.howToStartTrainingLink,
                            target: "_blank"
                          }, _toDisplayString(_ctx.$t("myCadac.trainingDetail.table.vdiInfo.firstTimeHelpLink")), 9, _hoisted_3)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_4, [
                (_ctx.canShowVdiInfo(item.data))
                  ? (_openBlock(), _createElementBlock("dl", _hoisted_5, [
                      _createElementVNode("dt", _hoisted_6, [
                        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.vm.isInstructor
										? _ctx.$t("myCadac.trainingDetail.table.vdiInfo.lblAccountDetails")
										: _ctx.$t("myCadac.trainingDetail.table.vdiInfo.lblYourAccountDetails")), 1),
                        _createVNode(_component_PopoverIcon, { class: "d-inline-flex" }, {
                          content: _withCtx(() => [
                            _createElementVNode("span", {
                              innerHTML: 
											_ctx.vm.isInstructor
												? _ctx.$t(
														'myCadac.trainingDetail.table.vdiInfo.accountDetailsPopOverText'
													)
												: _ctx.$t(
														'myCadac.trainingDetail.table.vdiInfo.yourAccountDetailsPopOverText'
													)
										
                            }, null, 8, _hoisted_9)
                          ]),
                          default: _withCtx(() => [
                            _hoisted_8
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("dt", null, _toDisplayString(_ctx.$t("myCadac.trainingDetail.table.vdiInfo.lblParticipant")), 1),
                        _createElementVNode("dd", null, _toDisplayString(item.data.email), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("dt", null, _toDisplayString(_ctx.$t("myCadac.trainingDetail.table.vdiInfo.lblAccountName")), 1),
                        _createElementVNode("dd", null, _toDisplayString(item.data.vmAccount), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("dt", null, _toDisplayString(_ctx.$t("myCadac.trainingDetail.table.vdiInfo.lblPassword")), 1),
                        _createElementVNode("dd", null, [
                          _createVNode(_component_Inplace, { closable: false }, {
                            display: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("myCadac.trainingDetail.table.vdiInfo.lblShowPassword")), 1)
                            ]),
                            content: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createElementVNode("p", {
                                  class: "m-0 limit-line-width text-truncate",
                                  title: _ctx.$t('myCadac.trainingDetail.table.vdiInfo.lblPassword')
                                }, _toDisplayString(item.data.vmPassword), 9, _hoisted_10),
                                _createVNode(_component_Button, {
                                  class: "p-button-outlined p-button-secondary copy-button",
                                  icon: "pi pi-copy",
                                  onClick: ($event: any) => (_ctx.copyTextToClipboard(item.data.vmPassword))
                                }, null, 8, ["onClick"])
                              ])
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("dl", _hoisted_11, [
                  _createElementVNode("dt", _hoisted_12, [
                    _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("myCadac.trainingDetail.table.vdiInfo.lblLinks")), 1),
                    _createVNode(_component_PopoverIcon, { class: "d-inline-flex" }, {
                      content: _withCtx(() => [
                        _createElementVNode("span", {
                          innerHTML: 
											_ctx.canShowVdiInfo(item.data)
												? _ctx.vm.isInstructor
													? _ctx.$t('myCadac.trainingDetail.table.vdiInfo.linksPopOverText')
													: _ctx.$t(
															'myCadac.trainingDetail.table.vdiInfo.yourLinksPopOverText'
														)
												: _ctx.$t('myCadac.trainingDetail.table.vdiInfo.bookCodesPopOverText')
										
                        }, null, 8, _hoisted_15)
                      ]),
                      default: _withCtx(() => [
                        _hoisted_14
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  (_ctx.vm.training?.teamUrl)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createElementVNode("dt", null, _toDisplayString(_ctx.$t("myCadac.trainingDetail.table.vdiInfo.lblMicrosoftTeams")), 1),
                        _createElementVNode("dd", null, [
                          _createElementVNode("div", null, [
                            _createElementVNode("p", {
                              class: "m-0 limit-line-width text-truncate",
                              title: _ctx.vm.training.teamUrl
                            }, _toDisplayString(_ctx.vm.training.teamUrl), 9, _hoisted_17),
                            _createVNode(_component_Button, {
                              class: "p-button-outlined p-button-secondary copy-button",
                              icon: "pi pi-copy",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.copyTextToClipboard(_ctx.vm.training.teamUrl)))
                            })
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.canShowVdiInfo(item.data))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createElementVNode("dt", null, _toDisplayString(_ctx.$t("myCadac.trainingDetail.table.vdiInfo.lblRemoteDesktop")), 1),
                        _createElementVNode("dd", null, [
                          _createElementVNode("div", null, [
                            _createElementVNode("p", {
                              class: "m-0 limit-line-width text-truncate",
                              title: item.data.vmUrl
                            }, _toDisplayString(item.data.vmUrl), 9, _hoisted_19),
                            _createVNode(_component_Button, {
                              class: "p-button-outlined p-button-secondary copy-button",
                              icon: "pi pi-copy",
                              onClick: ($event: any) => (_ctx.copyTextToClipboard(item.data.vmUrl))
                            }, null, 8, ["onClick"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.canShowBookCodes(item.data))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createElementVNode("dt", null, _toDisplayString(_ctx.$t("myCadac.trainingDetail.table.vdiInfo.lblStudyBookCodes")), 1),
                        _createElementVNode("dd", null, [
                          _createElementVNode("ol", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.data.studyBookCodes, (code) => {
                              return (_openBlock(), _createElementBlock("li", { key: code }, [
                                code
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                      _createElementVNode("p", {
                                        class: "m-0 limit-line-width text-truncate",
                                        title: code
                                      }, _toDisplayString(code), 9, _hoisted_22),
                                      _createVNode(_component_Button, {
                                        class: "p-button-outlined p-button-secondary copy-button ml-1",
                                        icon: "pi pi-copy",
                                        onClick: ($event: any) => (_ctx.copyTextToClipboard(code))
                                      }, null, 8, ["onClick"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.vm.canRestartVdi)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      class: "p-button-danger",
                      disabled: _ctx.isRestartVdiButtonLocked,
                      icon: "pi pi-refresh",
                      label: _ctx.$t('myCadac.trainingDetail.button.restartMachine'),
                      title: _ctx.$t('myCadac.trainingDetail.button.restartMachine'),
                      onClick: ($event: any) => (_ctx.restartVdi(item.data))
                    }, null, 8, ["disabled", "label", "title", "onClick"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, { "header-style": "width: 1.75rem" }, {
              body: _withCtx((item) => [
                (_ctx.canExpandRow(item.data))
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      class: _normalizeClass(_ctx.isSmallScreen ? 'p-button-link text-primary' : 'p-row-toggler p-link'),
                      icon: _ctx.isExpandedRow(item.data) ? 'pi pi-chevron-down' : 'pi pi-chevron-right',
                      label: 
						_ctx.isSmallScreen
							? _ctx.isExpandedRow(item.data)
								? _ctx.$t('myCadac.trainingDetail.table.lblHideExpandButton')
								: _ctx.$t('myCadac.trainingDetail.table.lblExpandButton')
							: ''
					,
                      title: 
						_ctx.isExpandedRow(item.data)
							? _ctx.$t('myCadac.trainingDetail.table.lblHideExpandButton')
							: _ctx.$t('myCadac.trainingDetail.table.lblExpandButton')
					,
                      onClick: ($event: any) => (_ctx.toggleRowExpansion(item.data))
                    }, null, 8, ["class", "icon", "label", "title", "onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              key: "firstName",
              "body-class": "",
              field: "firstName",
              header: _ctx.$t('myCadac.trainingDetail.table.firstName')
            }, {
              editor: _withCtx((participant) => [
                _createVNode(_component_InputText, {
                  modelValue: participant.data[participant.column.props.field],
                  "onUpdate:modelValue": ($event: any) => ((participant.data[participant.column.props.field]) = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              key: "lastName",
              "body-class": "",
              field: "lastName",
              header: _ctx.$t('myCadac.trainingDetail.table.lastName')
            }, {
              editor: _withCtx((participant) => [
                _createVNode(_component_InputText, {
                  modelValue: participant.data[participant.column.props.field],
                  "onUpdate:modelValue": ($event: any) => ((participant.data[participant.column.props.field]) = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              key: "email",
              "body-class": "",
              field: "email",
              header: _ctx.$t('myCadac.trainingDetail.table.email')
            }, {
              editor: _withCtx((participant) => [
                _createVNode(_component_InputText, {
                  modelValue: participant.data[participant.column.props.field],
                  "onUpdate:modelValue": ($event: any) => ((participant.data[participant.column.props.field]) = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              key: "actions",
              "body-class": "text-right",
              sortable: false
            }, {
              body: _withCtx((item) => [
                (_ctx.canEditParticipant)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      class: "p-button-icon p-button-rounded p-button-text p-button-raised",
                      icon: "pi pi-pencil",
                      label: _ctx.isSmallScreen ? _ctx.$t('myCadac.trainingDetail.table.lblEditButton') : '',
                      title: _ctx.$t('myCadac.trainingDetail.table.lblEditButton'),
                      onClick: ($event: any) => (_ctx.onEditClick(item.data))
                    }, null, 8, ["label", "title", "onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.canRemoveParticipant)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      class: "p-button-icon p-button-rounded p-button-text p-button-raised p-button-danger ml-1",
                      icon: "pi pi-trash",
                      label: _ctx.isSmallScreen ? _ctx.$t('common.remove') : '',
                      title: _ctx.$t('common.remove'),
                      onClick: ($event: any) => (_ctx.confirmRemoveParticipant(item.data))
                    }, null, 8, ["label", "title", "onClick"]))
                  : _createCommentVNode("", true)
              ]),
              editor: _withCtx((item) => [
                _createVNode(_component_Button, {
                  class: "p-button-icon p-button-rounded p-button-text p-button-sm p-button-secondary",
                  icon: "pi pi-times",
                  title: _ctx.$t('myCadac.trainingDetail.table.lblCancelRowEditButon'),
                  onClick: ($event: any) => (_ctx.cancelEditingRows(item.data))
                }, null, 8, ["title", "onClick"]),
                _createVNode(_component_Button, {
                  class: "p-button-icon p-button-rounded p-button-sm p-button-success ml-2",
                  icon: "pi pi-check",
                  loading: _ctx.isSpinnerVisible(item.data.id),
                  title: _ctx.$t('myCadac.trainingDetail.table.lblSaveRowEditButon'),
                  onClick: ($event: any) => (_ctx.updateParticipant(item.data))
                }, null, 8, ["loading", "title", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["editingRows", "expanded-rows", "row-class", "row-hover", "value", "onRowClick"]))
      : _createCommentVNode("", true),
    (_ctx.trainingStore.isTrainingAddParticipantModalVisible)
      ? (_openBlock(), _createBlock(_component_TrainingAddParticipantsModal, {
          key: 1,
          onAddParticipant: _ctx.addParticipant
        }, null, 8, ["onAddParticipant"]))
      : _createCommentVNode("", true)
  ], 64))
}